import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "gfu-header__actions gfu-navbar-nav",
  "data-qa": "navbar-header-actions"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-navbar-item _screen--none _screen--flex-m"
}
const _hoisted_3 = { class: "gfu-navbar-btn" }
const _hoisted_4 = { class: "gfu-navbar-item" }
const _hoisted_5 = { class: "gfu-navbar-btn" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sign_up_button = _resolveComponent("sign-up-button")
  const _component_login_button = _resolveComponent("login-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.introText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString($props.introText), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        ($options.isSignUp)
          ? (_openBlock(), _createBlock(_component_sign_up_button, {
              key: 0,
              "is-hidden-in-pwa": ""
            }))
          : (_openBlock(), _createBlock(_component_login_button, {
              key: 1,
              "is-hidden-in-pwa": ""
            }))
      ])
    ])
  ]))
}